import { useState, useEffect, useCallback } from 'react';

// Hook para manejar el recordatorio de exportación diaria
const useExportReminder = () => {
  const [showReminder, setShowReminder] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [reminderShownToday, setReminderShownToday] = useState(false);

  // Verificar si ya se mostró el recordatorio hoy
  useEffect(() => {
    const today = new Date().toDateString();
    const lastReminderDate = localStorage.getItem('lastExportReminderDate');
    
    if (lastReminderDate === today) {
      setReminderShownToday(true);
    }
  }, []);

  // Función para verificar si es hora de mostrar el recordatorio
  const checkReminderTime = useCallback(() => {
    const now = new Date();
    const hour = now.getHours();
    const minutes = now.getMinutes();
    
    // Mostrar recordatorio a las 18:00 (solo una vez por día)
    const isReminderTime = hour === 18 && minutes === 0;
    
    // Solo en días hábiles (lunes a viernes)
    const dayOfWeek = now.getDay(); // 0 = domingo, 6 = sábado
    const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
    
    if (isReminderTime && isWeekday && !reminderShownToday) {
      setShowReminder(true);
      setCurrentTime(now);
      
      // Marcar que ya se mostró hoy
      const today = now.toDateString();
      localStorage.setItem('lastExportReminderDate', today);
      setReminderShownToday(true);
    }
  }, [reminderShownToday]);

  // Verificar cada minuto si es hora del recordatorio
  useEffect(() => {
    // Verificar inmediatamente al cargar
    checkReminderTime();
    
    // Luego verificar cada minuto
    const interval = setInterval(checkReminderTime, 60000); // 60 segundos
    
    return () => clearInterval(interval);
  }, [checkReminderTime]);

  // Función para cerrar el recordatorio
  const dismissReminder = useCallback(() => {
    setShowReminder(false);
  }, []);

  // Función para cerrar y no mostrar más hoy (si usuario hace export)
  const handleExportAction = useCallback(() => {
    setShowReminder(false);
    // Ya está marcado como mostrado hoy, no se volverá a mostrar
  }, []);

  return {
    showReminder,
    currentTime,
    dismissReminder,
    handleExportAction
  };
};

export default useExportReminder;